// Will also be used for 'space'
const sizes = {
  navigationHeight: `61px`,
  navigationWithSubHeight: `111px`,
}

export default sizes
